module.exports = __webpack_public_path__ + "img/yeminli-sosyal-arabuluculuk.cd981bd7.jpg";